var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import OpportunityStageHistoryDomainService from "../Domain/OpportunityStageHistory/OpportunityStageHistory.service";
const BASE_URL = "/aviso/opportunityStageHistory";
export default class OpportunityStageHistoryService {
    static getHistoryForOpportunity(opportunityId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getHistoryForOpportunity", {
                opportunityId,
            });
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                fromStageIds: search.fromStageIds,
                toStageIds: search.toStageIds,
                opportunityIds: search.opportunityIds,
                fromStageEntryDateFrom: search.fromStageEntryDateFrom,
                fromStageEntryDateTo: search.fromStageEntryDateTo,
                fromStageExitDateFrom: search.fromStageExitDateFrom,
                fromStageExitDateTo: search.fromStageExitDateTo,
                createdDateFrom: search.createdDateFrom,
                createdDateTo: search.createdDateTo,
                createdByIds: search.createdByIds,
                query: search.query,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, resp), { data: resp.data.map(OpportunityStageHistoryDomainService.fromJSON) });
        });
    }
    static get(opportunityStageHistoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                opportunityStageHistoryId,
            });
        });
    }
    static timeInStage(opportunityId, stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/timeInStage", {
                opportunityId,
                stageId,
            });
        });
    }
    static timeInPipeline(opportunityId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/timeInPipeline", {
                opportunityId,
            });
        });
    }
}
